import {
    CardWexRecord,
    FetchState,
    WexDebitCardManageCardViewState,
    WexDebitCardsState
} from "@/shared/types";

import * as CardService from "@/shared/api/cardService";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

export const initialState: WexDebitCardsState = {
    fetchState: FetchState.Uninitialized,
    wexDebitCards: [],
    wexNewCardRequestModalOpen: false,
    wexManageCardModalOpen: false,
    WexDebitCardManageCardViewState: WexDebitCardManageCardViewState.ManageCardForm,
    RowSelected: null
};

export const useWexDebitCardsStore = defineStore("wexDebitCards", {
    state: (): WexDebitCardsState => (_.cloneDeep(initialState)),
    getters: {
        isLoaded: state => state.fetchState === FetchState.Loaded,
    },
    actions: {
        setFetchState (fetchState: FetchState) {
            this.fetchState = fetchState;
        },

        setWexManageCardState (location: WexDebitCardManageCardViewState) {
            this.WexDebitCardManageCardViewState = location;
        },

        setWexDebitCardInfos (wexDebitCards: CardWexRecord[]) {
            this.wexDebitCards = wexDebitCards;
            this.wexDebitCardFetchState = FetchState.Loaded;
        },
        setRowSelected (wexDebitCard: CardWexRecord) {
            this.RowSelected = wexDebitCard;
        },
        getWexDebitCards (): Promise<any> {
            if (this.fetchState !== FetchState.Uninitialized) {
                return Promise.resolve();
            }

            const featureFlagStore = useFeatureFlagStore();

            if (featureFlagStore.flags.bend20636WexDebitCardUi === false) {
                return Promise.resolve();
            }

            this.setFetchState(FetchState.Loading);
            return CardService.getWexCardList()
                .then(response => {
                    this.setWexDebitCardInfos(response.data.cards);
                }).catch(err => {
                    return storeHelper.handleError({ error: err, rethrow: true });
                });
        },
        setNewCardRequestModalOpen (isOpen: boolean) {
            this.wexNewCardRequestModalOpen = isOpen;
        },
        setManageCardModalOpen (isOpen: boolean) {
            this.wexManageCardModalOpen = isOpen;
        },
        setWexDebitCardManageCardViewState (state: WexDebitCardManageCardViewState): Promise<any> {
            this.setWexManageCardState(state);
            return Promise.resolve();
        },
        setDebitCardRowSelected (wexRecord: CardWexRecord): Promise<any> {
            this.setRowSelected(wexRecord);
            return Promise.resolve();
        }
    }
});